import { render, staticRenderFns } from "./reviewBlock.vue?vue&type=template&id=48f75ca8&"
import script from "./reviewBlock.vue?vue&type=script&lang=js&"
export * from "./reviewBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports